import { useMutation, UseMutationResult } from '@taxdown/zeno-sama-query';
import i18n from 'Services/i18n';
import NotificationService, { AlertTypes } from 'Services/notification';
import UserService from 'Services/user';
import { history } from 'Store';
import { routes } from 'Constants/routes';
import { IsPreviousYear, QueryKeys, ResponseType } from 'Types/common';

export type SavePhoneHookType = {
  route?: string;
  onHideModal?: () => unknown;
  isPreviousYears?: IsPreviousYear;
};

export const useFetchSaveUserphone = ({
  route,
  onHideModal,
  isPreviousYears,
}: SavePhoneHookType): UseMutationResult<ResponseType<unknown>, string> =>
  useMutation([QueryKeys.SAVE_PHONE_KEY], UserService.setUserPhone, {
    onSuccess: async () => {
      if (route && !isPreviousYears?.products?.isPreviousYear) {
        history.push(route);
      }
      if (isPreviousYears?.products?.isPreviousYear) {
        history.push(routes.DATAGATHERING_QUIZ, {
          products: isPreviousYears?.products ?? {},
        });
      }
    },
    onError: () => {
      NotificationService.sendNotification(i18n.t('common:SavePhone.error'), AlertTypes.error);
    },
    onSettled: () => {
      if (onHideModal) {
        onHideModal();
      }
    },
  });
